{
  "validation.maxAttachments": "kun {{max}} vedhæftede filer er tilladt",
  "validation.minAttachments": "mindst {{min}} vedhæftede filer er påkrævet",
  "validation.maxAttachmentSize": "Vedhæftede filer kan ikke være større end {{max}} Megabytes",
  "validation.attachmentListItemRequired": "Venligst vedhæft en fil til \"{{category}}\".",
  "validation.attachmentListItemMaxAttachments": "Du kan kun tilføje op til {{max}} vedhæftede filer til \"{{category}}\".",
  "validation.attachmentListItemMaxAttachmentSize": "{{category}}-vedhæftninger må ikke være større end {{max}} megabyte",
  "attachment.bsoCategory.DiagnosticReport": "Diagnose rapport",
  "attachment.bsoCategory.InvoiceDocument": "Fakturadokument",
  "attachment.bsoCategory.ShippingDocument": "Forsendelsesdokument",
  "attachment.bsoCategory.Letter": "Brev",
  "attachment.bsoCategory.PictureReference": "Billedreference",
  "attachment.bsoCategory.BugReport": "Fejlrapport",
  "attachment.bsoCategory.Other": "Andet",
  "attachment.bsoCategory.Unclassified": "Uklassificeret",
  "attachment.bsoCategory.ServiceForms": "Serviceformular",
  "attachment.bsoCategory.RegistrationDocument": "Registreringsdokument",
  "attachment.bsoCategory.ShopInside": "Billede af butiksinteriør",
  "attachment.bsoCategory.ShopImageMigration": "Butiksbillede Migration",
  "attachment.bsoCategory.ShopImage": "Billede af butiksfacade",
  "attachment.uploadButton": "Upload {{category}}",
  "attachment.uploadDropdown": "Upload en fil"
}